export const STATUS_FILTER_OPTIONS = ['Draft', 'Scheduled', 'Sent', 'Processing', 'Ready', 'Failed'] as const;

export const RECIPIENT_STATUS_OPTIONS = ['Pending', 'Sent', 'Opened', 'Failed', 'Reported'] as const;
